import { Alert, Button, Modal, Table } from 'react-bootstrap';
import { IPreselectDonorInfo } from '@nkr/models/index';
import { IRowData } from '../donor-pre-select/models';

interface IProps {
    show: boolean,
    reasons: string[],
    list: IRowData[],
    isPreselectPage?: boolean,
    onYes: () => void,
    onNo: () => void
}

const ConfirmBulkUpdate = (props: IProps) => {
    const getDonorCenter = (donor: IPreselectDonorInfo) => {
        if (donor.rdnCenterId > 0) {
            return <>{donor.centerAlias} (<span style={{ color: 'red' }}>{donor.rdnCenterAlias}</span>)</>;
        } else {
            return <>{donor.centerAlias}</>;
        }
    };

    const getText = () => {
        return { action: 'Reason for decline: ' + props.reasons.join(', '), confirm: 'decline' }
    }

    const text = getText();

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onNo}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Bulk Decline</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='warning' style={{ textAlign: 'center' }}>
                    <div style={{ marginBottom: 5 }}>You have selected the donors listed below to bulk-decline.</div>

                    <div style={{ marginBottom: 5, fontWeight: 'bold' }}>
                        {text.action}
                    </div>

                    <div>Please confirm that you wish to {text.confirm} all of them.</div>
                </Alert>

                <Table condensed bordered striped style={{ marginBottom: 0 }}>
                    <thead>
                        <tr>
                            {props.isPreselectPage && <th style={{ textAlign: 'center' }}>Recipient Alias</th>}
                            <th style={{ textAlign: 'center' }}>Donor Center</th>
                            <th style={{ textAlign: 'center' }}>Donor Alias</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.list.map(x =>
                            <tr key={'donor-' + x.donor.id}>
                                {props.isPreselectPage && <td style={{ textAlign: 'center' }}>{x.recipient?.alias}</td>}
                                <td style={{ textAlign: 'center' }}>{getDonorCenter(x.donor)}</td>
                                <td style={{ textAlign: 'center' }}>{x.donor.alias}</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onYes}>Yes, Continue</Button>
                <Button onClick={props.onNo}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmBulkUpdate;